import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Typography } from '@mui/material';

const Footer: React.FC = () => {
  const linkStyle: React.CSSProperties = {
    color: '#7A5F4E',
    textDecoration: 'none',
    fontSize: '0.75rem',
    transition: 'color 0.2s',
  };

  return (
    <Box
      component="footer"
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: { xs: 0.5, sm: 1 },
        py: 1.5,
        px: 3,
        borderTop: '1px solid #F0E4CE',
        backgroundColor: '#FFFFFF',
        flexShrink: 0,
      }}
    >
      <Link to="/faq" style={linkStyle} onMouseOver={(e) => (e.currentTarget.style.color = '#3A8C8C')} onMouseOut={(e) => (e.currentTarget.style.color = '#7A5F4E')}>
        FAQ
      </Link>
      <Typography variant="caption" sx={{ color: '#F0E4CE', mx: 0.5, display: { xs: 'none', sm: 'inline' } }}>
        |
      </Typography>
      <Link to="/about" style={linkStyle} onMouseOver={(e) => (e.currentTarget.style.color = '#3A8C8C')} onMouseOut={(e) => (e.currentTarget.style.color = '#7A5F4E')}>
        About
      </Link>
      <Typography variant="caption" sx={{ color: '#F0E4CE', mx: 0.5, display: { xs: 'none', sm: 'inline' } }}>
        |
      </Typography>
      <Link to="/terms" style={linkStyle} onMouseOver={(e) => (e.currentTarget.style.color = '#3A8C8C')} onMouseOut={(e) => (e.currentTarget.style.color = '#7A5F4E')}>
        Terms of Service
      </Link>
      <Typography variant="caption" sx={{ color: '#F0E4CE', mx: 0.5, display: { xs: 'none', sm: 'inline' } }}>
        |
      </Typography>
      <Link to="/privacy" style={linkStyle} onMouseOver={(e) => (e.currentTarget.style.color = '#3A8C8C')} onMouseOut={(e) => (e.currentTarget.style.color = '#7A5F4E')}>
        Privacy Policy
      </Link>
      <Typography variant="caption" sx={{ color: '#F0E4CE', mx: 0.5, display: { xs: 'none', sm: 'inline' } }}>
        |
      </Typography>
      <Link to="/security" style={linkStyle} onMouseOver={(e) => (e.currentTarget.style.color = '#3A8C8C')} onMouseOut={(e) => (e.currentTarget.style.color = '#7A5F4E')}>
        Security
      </Link>
      <Typography variant="caption" sx={{ color: '#F0E4CE', mx: 0.5, display: { xs: 'none', sm: 'inline' } }}>
        |
      </Typography>
      <Link to="/risk-disclosure" style={linkStyle} onMouseOver={(e) => (e.currentTarget.style.color = '#3A8C8C')} onMouseOut={(e) => (e.currentTarget.style.color = '#7A5F4E')}>
        Risk Disclosure
      </Link>
      <Typography variant="caption" sx={{ color: '#F0E4CE', mx: 0.5, display: { xs: 'none', sm: 'inline' } }}>
        |
      </Typography>
      <Link to="/compliance" style={linkStyle} onMouseOver={(e) => (e.currentTarget.style.color = '#3A8C8C')} onMouseOut={(e) => (e.currentTarget.style.color = '#7A5F4E')}>
        Compliance
      </Link>
    </Box>
  );
};

export default Footer;
